import { parse } from 'papaparse';
export async function parseMetaFile(file) {
    const data = file instanceof File ? file : await file.text();
    return new Promise((complete, error) => {
        parse(data, {
            header: true,
            dynamicTyping: true,
            complete,
            error,
        });
    });
}
